import React from "react";

export default function TrackStatusHistory({ data, onLeaveApp }) {
  return (
    <div>
      <h3 className="font-bold text-lg mb-8">Track Your Application</h3>
      <div class="w-full bg-white rounded-lg large-shadow md:mt-0 sm:max-w-2xl mx-auto xl:p-0 mb-8">
        <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
          <div className="flex items-center">
            <div className="lg:w-56 w-1/2">
              <label>Application Reference:</label>
            </div>
            <div className="flex-1 ml-4 text-blue-700">{data.app_ref}</div>
          </div>
          <div className="flex items-center">
            <div className="lg:w-56 w-1/2">
              <label>Last Update:</label>
            </div>
            <div className="flex-1 ml-4">{data.last_update}</div>
          </div>
          <div className="flex items-center">
            <div className="lg:w-56 w-1/2">
              <label>Status:</label>
            </div>
            <div className="flex-1 ml-4">{data.current_status}</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center">
        <button
          className="border border-orange-600 rounded-full px-5 py-3 text-center bg-orange-600 text-white hover:bg-orange-700 transition duration-200 focus:outline-none inline-flex items-center"
          onClick={onLeaveApp}
        >
          <svg
            className="w-5 h-5 mr-1"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            ></path>
          </svg>
          Return to Home Page
        </button>
      </div>
    </div>
  );
}
